<template functional>
  <div class="d-flex flex-column align-items-center">
    <div class="mb-4">
      <span class="c-d91b1c" v-if="props.modalConfig.type === 'rejected'">
        <i class="far fa-times-circle fa-5x"/>
      </span>
      <span class="c-78a735" v-else-if="props.modalConfig.type === 'completed'">
        <i class="far fa-check-circle fa-5x"/>
      </span>
    </div>
    <div class="f-bold s-14" style="text-align: center">
      <span v-if="props.modalConfig.type === 'rejected'">
        {{ props.modalConfig.message }}
      </span>
      <span v-else-if="props.modalConfig.type === 'completed'">
        {{ props.modalConfig.message }}
      </span>
    </div>
    <a :href="props.modalConfig.previewLink"
                 target="_blank"
                 class="d-flex flex-row mt-3 align-items-center c-232b2b"
                 v-if="props.modalConfig.type === 'completed'">
      <i class="far fa-arrow-down"/>
      <span class="ml-1">
        <u>Download PDF</u>
      </span>
    </a>
  </div>
</template>

<script>
export default {
  name: 'ResultInformation',
};
</script>

<style scoped>
.c-d91b1c {
  color: #d91b1c;
}

.c-78a735 {
  color: #78a735;
}
</style>
